import HelperMixin from '../../Shared/HelperMixin.vue';

// CN-16 / UI-10 — §3 cancellation policy editor.
// Backed by api/admin/CancellationPolicies (List / Create / Update / Delete).
// ActorType: 1=Rider 2=Driver 3=Admin 4=NoShow.

export default {
    name: 'CancellationPolicy',
    mixins: [HelperMixin],

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        if (!this.requireUserType([1])) return;
        await this.Load();
    },

    data() {
        return {
            Policies: [],
            Form: {
                Id: null,
                ActorType: 1,
                AtLevel: null,
                WithinMinutes: null,
                FeePercent: null,
                FixedFee: null,
                Description: ''
            },
            Saving: false,
        };
    },

    methods: {
        ActorLabel(t) {
            if (t === 1) return 'Rider';
            if (t === 2) return 'Driver';
            if (t === 3) return 'Admin';
            if (t === 4) return 'NoShow';
            return '—';
        },
        ActorClass(t) {
            if (t === 1) return 'pill-rider';
            if (t === 2) return 'pill-driver';
            if (t === 3) return 'pill-admin';
            if (t === 4) return 'pill-noshow';
            return '';
        },
        async Load() {
            this.$blockUI.Start();
            try {
                const res = await this.$http.GetCancellationPolicies();
                this.Policies = res.data || [];
            } catch (e) {
                this.Policies = [];
            } finally {
                this.$blockUI.Stop();
            }
        },
        ResetForm() {
            this.Form = {
                Id: null,
                ActorType: 1,
                AtLevel: null,
                WithinMinutes: null,
                FeePercent: null,
                FixedFee: null,
                Description: ''
            };
        },
        EditRow(p) {
            this.Form = {
                Id: p.id,
                ActorType: p.actorType,
                AtLevel: p.atLevel,
                WithinMinutes: p.withinMinutes,
                FeePercent: p.feePercent,
                FixedFee: p.fixedFee,
                Description: p.description || ''
            };
            try { window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' }); } catch (e) { /* scroll fallback ignored */ }
        },
        async Save() {
            if (this.Saving) return;
            this.Saving = true;
            try {
                const body = {
                    ActorType: this.Form.ActorType,
                    AtLevel: this.Form.AtLevel || null,
                    WithinMinutes: this.Form.WithinMinutes || null,
                    FeePercent: this.Form.FeePercent || null,
                    FixedFee: this.Form.FixedFee || null,
                    Description: this.Form.Description
                };
                if (this.Form.Id) {
                    await this.$http.UpdateCancellationPolicy(this.Form.Id, body);
                } else {
                    await this.$http.CreateCancellationPolicy(body);
                }
                if (this.$helper && this.$helper.SuccessMessage) this.$helper.SuccessMessage('تم الحفظ');
                else alert('تم الحفظ');
                this.ResetForm();
                await this.Load();
            } catch (e) {
                const msg = e?.response?.data?.Message || e?.response?.data?.Code || 'فشل الحفظ';
                if (this.$helper && this.$helper.FailMessage) this.$helper.FailMessage(msg);
                else alert(msg);
            } finally {
                this.Saving = false;
            }
        },
        async Delete(id) {
            if (!confirm('هل أنت متأكد من حذف هذه القاعدة؟')) return;
            try {
                await this.$http.DeleteCancellationPolicy(id);
                await this.Load();
            } catch (e) {
                const msg = e?.response?.data?.Message || 'فشل الحذف';
                if (this.$helper && this.$helper.FailMessage) this.$helper.FailMessage(msg);
                else alert(msg);
            }
        }
    }
};
